import { z } from "zod";
import { paginate } from "../pagination.js";
import { participantSchema } from "../schemas/index.js";
export class ParticipantsResource {
    http;
    constructor(http) {
        this.http = http;
    }
    list(params) {
        return this.http.request({
            method: "GET",
            path: "/participants",
            endpoint: "participants.list",
            query: { league_id: params.league_id, limit: params.limit, cursor: params.cursor },
            dataSchema: z.array(participantSchema),
        });
    }
    get(id) {
        return this.http.request({
            method: "GET",
            path: `/participants/${encodeURIComponent(id)}`,
            endpoint: "participants.get",
            dataSchema: participantSchema,
        });
    }
    iterate(params) {
        return paginate((cursor) => this.list({ ...params, cursor }));
    }
}
//# sourceMappingURL=participants.js.map